import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message',
  template: '',
  styles: []
})
export class MessageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // Announcements moved into the unified Messages screen.
    this.router.navigate(['/notification'], { replaceUrl: true });
  }
}
